import { render, staticRenderFns } from "./Fapiao.vue?vue&type=template&id=08fa5c6e"
import script from "./Fapiao.vue?vue&type=script&lang=js"
export * from "./Fapiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports